<div class="wch-home">

  <!-- Hero -->
  <div class="wch-hero">
    <h1 class="wch-hero__title">Well Chron</h1>
    <p class="wch-hero__greeting" *ngIf="displayName">
      {{ greeting }}, <strong>{{ displayName }}</strong>
    </p>
    <p class="wch-hero__sub">What would you like to work on today?</p>

    <!-- Stat pills — admin only, lives inside the hero -->
    <div class="wch-hero__stats" *ngIf="showStats && !statsLoading && stats">
      <a routerLink="/pending-users"
         class="wch-hero__pill"
         [class.wch-hero__pill--alert]="stats.pendingUsers > 0"
         *ngIf="stats.pendingUsers !== null">
        <i class="bi bi-hourglass-split"></i>
        <strong>{{ stats.pendingUsers }}</strong><span>pending</span>
      </a>
      <a routerLink="/user-management"
         class="wch-hero__pill"
         *ngIf="stats.totalUsers !== null">
        <i class="bi bi-people"></i>
        <strong>{{ stats.totalUsers }}</strong><span>users</span>
      </a>
      <a routerLink="/client"
         class="wch-hero__pill"
         *ngIf="stats.totalClients !== null">
        <i class="bi bi-building"></i>
        <strong>{{ stats.totalClients }}</strong><span>clients</span>
      </a>
    </div>
  </div>

  <!-- Module Cards -->
  <div class="wch-cards">

    <!-- Dashboards -->
    <a routerLink="/dashboards" *ngIf="loginService.userOptional && loginService.userOptional.dashboards.length > 0" class="wch-card wch-card--blue">
      <div class="wch-card__icon">
        <i class="bi bi-speedometer2"></i>
      </div>
      <div class="wch-card__body">
        <div class="wch-card__title">Dashboards</div>
        <div class="wch-card__desc">View and manage your well data dashboards</div>
      </div>
      <i class="bi bi-arrow-right wch-card__arrow"></i>
    </a>

    <!-- FracX -->
    <a *ngIf="loginService.userOptional?.enableFracX || loginService.userOptional?.isGlobalAdmin"
       routerLink="/schedules"
       class="wch-card wch-card--green">
      <div class="wch-card__icon">
        <i class="bi bi-calendar3"></i>
      </div>
      <div class="wch-card__body">
        <div class="wch-card__title">FracX</div>
        <div class="wch-card__desc">Track and review frac schedules across your operations</div>
      </div>
      <i class="bi bi-arrow-right wch-card__arrow"></i>
    </a>

    <!-- AquaTrade -->
    <a *ngIf="loginService.userOptional?.enableAquatrade || loginService.userOptional?.enableAquashare"
       routerLink="/watersharing"
       class="wch-card wch-card--teal">
      <div class="wch-card__icon">
        <i class="bi bi-droplet-half"></i>
      </div>
      <div class="wch-card__body">
        <div class="wch-card__title">AquaTrade</div>
        <div class="wch-card__desc">Water trading and sharing for produced water management</div>
      </div>
      <i class="bi bi-arrow-right wch-card__arrow"></i>
    </a>

    <!-- User Management (company admin+) -->
    <a *ngIf="loginService.userOptional?.isCompanyAdmin || loginService.userOptional?.isGlobalAdmin"
       routerLink="/user-management"
       class="wch-card wch-card--slate">
      <div class="wch-card__icon">
        <i class="bi bi-people"></i>
      </div>
      <div class="wch-card__body">
        <div class="wch-card__title">User Management</div>
        <div class="wch-card__desc">Manage users, roles, and permissions for your organization</div>
      </div>
      <i class="bi bi-arrow-right wch-card__arrow"></i>
    </a>

    <!-- Clients (global admin) -->
    <a *ngIf="loginService.userOptional?.isGlobalAdmin"
       routerLink="/client"
       class="wch-card wch-card--slate">
      <div class="wch-card__icon">
        <i class="bi bi-building"></i>
      </div>
      <div class="wch-card__body">
        <div class="wch-card__title">Client Management</div>
        <div class="wch-card__desc">Manage client organizations and their settings</div>
      </div>
      <i class="bi bi-arrow-right wch-card__arrow"></i>
    </a>

  </div>

  <!-- Recently Viewed -->
  <app-recently-viewed></app-recently-viewed>

</div>
